import { useState } from "react";

export const KarmaPoolContentPlayingManager = () => {

    const [currentlyPlayingContent, setCurrentlyPlayingContent] = useState(() => {
        return { id: null, type: null };
    });

    // For YouTube
    if (!window.youtubePlayersToInitialize) {
        window.youtubePlayersToInitialize = [];
    }

    if (!window.initializeYouTubePlayers) {
        window.initializeYouTubePlayers = function () {
            window.youtubePlayersToInitialize.forEach(createPlayer => createPlayer());
        };
    }
    window.onYouTubeIframeAPIReady = window.initializeYouTubePlayers;


    return {
        currentlyPlayingContent, setCurrentlyPlayingContent
    };
}
